import type { GenerationQuality } from '../../data/types/GenerationParams'

export type PlaygroundStatus =
  | 'Pending'
  | 'Running'
  | 'Completed'
  | 'CompletedWithErrors'
  | 'Failed'
  | 'Cancelled'

export type PlaygroundGenerationRequest = {
  prompt: string
  numberOfImages: number
  quality: GenerationQuality
  resolution: string
  imageProvider: string | null
  imageStylePromptId: string | null
  references: { fileId: string; storagePath: string }[]
}

export type AcceptedPlaygroundGeneration = {
  activityId: string
  workspaceId: string
  numberOfImages: number
  status: PlaygroundStatus
  statusUrl: string
}

export type PlaygroundGeneration = {
  activityId: string
  workspaceId: string
  numberOfImages: number
  status: PlaygroundStatus
  generatedCount: number
  resultFileIds: string[]
  error: string | null
  canCancel: boolean
}

export function isPlaygroundPending(status: PlaygroundStatus) {
  return status === 'Pending' || status === 'Running'
}

export function isPlaygroundTerminal(status: PlaygroundStatus) {
  return !isPlaygroundPending(status)
}
